import getCollection from './getCollection'
import getDoc from 'actions/base/getDoc'

const newGroupDoc = async () => getDoc(getCollection())

export default newGroupDoc
